import { callPostApi, callPutApi } from "./api";

export async function getCmsMenuList(data) {
      // return this.interceptors.POST("page", data);
      try {
            const response = await callPostApi({ url: "menus/menu-list", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getMenuWithSequence(data) {
      try {
            const response = await callPostApi({ url: "menus/menu-sequence", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function setMenuWithSequence(data) {
      try {
            const response = await callPostApi({ url: "menus/set-menu-sequence", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

// add location menu
export async function addLocationMenu(data) {
      try {
            const response = await callPostApi({ url: "menus/add-location-menu", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

// update location menu
export async function updateLocationMenu(data) {
      try {
            const response = await callPutApi({ url: "menus/update-location-menu", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}